import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs">
      <Link to="/" className="text-foreground-500 transition-colors hover:text-primary-400">
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-500" />
          {item.to ? (
            <Link to={item.to} className="text-foreground-500 transition-colors hover:text-primary-400">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}